import { appModulesToRequiredUserRoles } from "@jugl-web/domain-resources/common/consts";
import { SubscriptionPlanModuleId } from "@jugl-web/rest-api";
import { PageNavParams } from "@web-src/modules/navigation/types";
import { ModulePagesConfig } from "@web-src/modules/navigation/types/ModulePagesConfigs";
import { lazy } from "react";

const InventoryItemsPage = lazy(() => import("./InventoryItemsPage"));
const InventoryDiscountsPage = lazy(() => import("./InventoryDiscountsPage"));
const InventoryWarehousesPage = lazy(() => import("./InventoryWarehousesPage"));
const InventoryItemFormPage = lazy(() => import("./InventoryItemFormPage"));
const InventoryItemEditStockFormPage = lazy(
  () => import("./InventoryItemEditStockFormPage")
);

export type InventoryPagesNavigationParams = {
  inventoryItems: PageNavParams;
  inventoryDiscounts: PageNavParams;
  inventoryWarehouses: PageNavParams;
  inventoryItemForm: PageNavParams;
  inventoryItemEditForm: PageNavParams<{
    id: string;
  }>;
  inventoryItemEditStockForm: PageNavParams<{
    id: string;
  }>;
};

export const inventoryPagesNavigationConfig: ModulePagesConfig<InventoryPagesNavigationParams> =
  {
    inventoryItems: {
      element: <InventoryItemsPage />,
      path: "inventory/items",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.inventory,
      requiredModules: [SubscriptionPlanModuleId.inventory],
    },
    inventoryItemForm: {
      element: <InventoryItemFormPage />,
      path: "/inventory/items/create",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.inventory,
      requiredModules: [SubscriptionPlanModuleId.inventory],
    },
    inventoryItemEditForm: {
      element: <InventoryItemFormPage />,
      path: "/inventory/items/edit/:id",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.inventory,
      requiredModules: [SubscriptionPlanModuleId.inventory],
    },
    inventoryItemEditStockForm: {
      element: <InventoryItemEditStockFormPage />,
      path: "/inventory/stock/edit/:id",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.inventory,
      requiredModules: [SubscriptionPlanModuleId.inventory],
    },
    inventoryDiscounts: {
      element: <InventoryDiscountsPage />,
      path: "inventory/discounts",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.inventory,
      requiredModules: [SubscriptionPlanModuleId.inventory],
    },
    inventoryWarehouses: {
      element: <InventoryWarehousesPage />,
      path: "inventory/warehouses",
      isPrivate: true,
      requiredUserRoles: appModulesToRequiredUserRoles.inventory,
      requiredModules: [SubscriptionPlanModuleId.inventory],
    },
  };
